import { render } from "./actionmodalnarrow.vue?vue&type=template&id=a8dea28c&scoped=true"
import script from "./actionmodalnarrow.vue?vue&type=script&lang=js"
export * from "./actionmodalnarrow.vue?vue&type=script&lang=js"

import "./actionmodalnarrow.vue?vue&type=style&index=0&id=a8dea28c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8dea28c"]])

export default __exports__